import React from "react";

import { components } from "react-select";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons"; // eslint-disable-line

const DropdownIndicator = (props: any) => {
  const { selectProps } = props;

  return (
    <components.DropdownIndicator {...props}>
      {selectProps.menuIsOpen ? (
        <ChevronUp size={10} color="white" />
      ) : (
        <ChevronDown size={10} color="white" />
      )}
    </components.DropdownIndicator>
  );
};
export default DropdownIndicator;
